import { useState } from "react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const TYPES = [["proprietario", "Proprietário(a)"], ["conjuge", "Cônjuge"], ["herdeiro", "Herdeiro(a)"], ["usufrutuario", "Usufrutuário(a)"]];

// «Adicionar titular»: nome, NIF, contacto e tipo de titular; ao guardar, a tarefa fecha e o CMI desbloqueia.
export function AddTitularDialog({ p, open, onClose, onDone }) {
  const [f, setF] = useState({ name: p.titular_suggest || "", nif: "", phone: "", email: "", kind: "proprietario" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target ? e.target.value : e });
  const save = async () => {
    setBusy(true);
    try {
      await api.post(`/processes/${p.id}/sellers/add`, f);
      toast.success("Titular acrescentado");
      onDone();
    } catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="add-titular-dialog">
        <DialogHeader>
          <DialogTitle>Adicionar titular</DialogTitle>
          <DialogDescription>{p.missing_titular ? `${p.missing_titular} · consta da certidão permanente.` : "Pessoa que consta da certidão permanente."}</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div><Label>Nome completo</Label><Input value={f.name} onChange={set("name")} data-testid="add-titular-name" /></div>
          <div className="grid grid-cols-2 gap-3">
            <div><Label>NIF</Label><Input value={f.nif} onChange={set("nif")} inputMode="numeric" maxLength={9} data-testid="add-titular-nif" /></div>
            <div><Label>Tipo de titular</Label>
              <Select value={f.kind} onValueChange={set("kind")}>
                <SelectTrigger data-testid="add-titular-kind"><SelectValue /></SelectTrigger>
                <SelectContent>{TYPES.map(([v, l]) => <SelectItem key={v} value={v} data-testid={`add-titular-kind-${v}`}>{l}</SelectItem>)}</SelectContent>
              </Select>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div><Label>Telemóvel</Label><Input value={f.phone} onChange={set("phone")} inputMode="tel" data-testid="add-titular-phone" /></div>
            <div><Label>Email</Label><Input value={f.email} onChange={set("email")} type="email" data-testid="add-titular-email" /></div>
          </div>
        </div>
        <div className="flex justify-end gap-2 mt-2">
          <Button variant="outline" onClick={onClose} data-testid="add-titular-cancel">Cancelar</Button>
          <Button onClick={save} disabled={busy || f.name.trim().length < 2} data-testid="add-titular-save">{busy ? "A guardar…" : "Guardar titular"}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
